import { ApiMetric, ApiOperator } from "@incendium/api";
import { ApiDimension } from "@incendium/api";
import { ContentExplorer } from "features/explorer";
import { ExplorerProvider } from "features/explorer";
import { TExploreConfig } from "features/explorer/types";
import { useMemo } from "react";

type Tab = "explore";

function ErrorPagesPage() {
  const config: TExploreConfig<Tab> = useMemo(
    () => ({
      explore: {
        title: "Error Pages Explorer",
        desc: `Discover your error pages and the impact they're having.`,
        type: "top",
        ranking: [],
        attributes: [
          {
            key: ApiDimension.DIMENSION_PAGE_STATUS_CODE,
            operator: ApiOperator.IS_GREATER_THAN_OR_EQUAL,
            value: "400",
          },
        ],
        analyseBy: {
          description: "Select between Locations or Paths.",
          grouping: [
            {
              option: "All Pages",
              dimensions: [
                ApiDimension.DIMENSION_PATH,
                ApiDimension.DIMENSION_LOCATION,
              ],
            },
            {
              option: "landing Pages",
              dimensions: [
                ApiDimension.DIMENSION_LANDING_PAGE_LOCATION,
                ApiDimension.DIMENSION_LANDING_PAGE_PATH,
              ],
            },
          ],
        },
      },
    }),
    []
  );

  return (
    <>
      <ExplorerProvider configs={config} type="explore">
        <ContentExplorer
          dimensionNoClick
          dontIncludeEmpty
          metrics={[
            ApiMetric.METRIC_PAGEVIEWS_COUNT,
            ApiMetric.METRIC_EXIT_RATE,
            ApiMetric.METRIC_MACRO_CONVERSION_RATE,
            ApiMetric.METRIC_SESSION_ADD_TO_CART_CLICK_RATE,
            ApiMetric.METRIC_REVENUE,
          ]}
          limit={1000}
          colWidths={{
            [ApiDimension.DIMENSION_EXIT_PAGE_PATH.toString()]: 300,
          }}
        />
      </ExplorerProvider>
    </>
  );
}

export default ErrorPagesPage;
